{
    "locale": "en-US",
    "error": {
        "unsupportedMethod": "Unsupported method: {method}"
    },
    "account": {
        "deleteTokenTooltip": "Permanently delete token?",
        "deleteToken": "Delete token",
        "apiAccountToken": "API Account Token",
        "createApiToken": "Create a new API Account Token",
        "createToken": "Create token",
        "existingTokens": "Existing tokens",
        "noApiTokensCreated": "No API Account Tokens have been created yet.",
        "description": "Description",
        "createdOn": "Created on",
        "token": "Token",
        "saveTokenWarning": "Save this token carefully, it cannot be displayed again.",
        "hint": "Note",
        "tokenCopiedNotification": "Token was copied to clipboard.",
        "registrationNotice": "Please note that an eInfo registration only works as a pre-listed dealer.",
        "registrationDescription": "Registering here gives you not only login access to our shop, but also access to our knowledge platform eInfo:",
        "informationAvailableTitle": "Information available anytime and anywhere",
        "statusQuery": "Status check for offers and orders",
        "downloadDocuments": "Download of offer, order confirmation and invoice",
        "downloadImages": "Download 2D and 3D image, as well as DXF file",
        "tracking": "Shipment tracking",
        "customerLink": "Inform customers and processors about statuses via link",
        "recognizeChargeable": "Directly recognize chargeable operations",
        "viewInvoices": "View sent invoices in the order",
        "andMore": "And more.",
        "oneClickSolutionTitle": "One-click solution",
        "inquiryExample": "Submit inquiry (e.g. for offer change)",
        "requestManual": "Request assembly instructions",
        "registerNow": "Register for free now:",
        "requestAccess": "Request access",
        "companyData": "Company data",
        "customerNumber": "Customer number",
        "company": "Company",
        "streetAndHouseNumber": "Street and house number",
        "postcode": "Postal code",
        "city": "City",
        "country": "Country",
        "personalAccess": "Personal access",
        "salutation": "Salutation",
        "firstName": "First name",
        "lastName": "Last name",
        "position": "Position",
        "email": "Email",
        "phone": "Phone",
        "mobilePhone": "Mobile phone",
        "fax": "Fax",
        "user": "User",
        "termsAcceptance": "I have read the",
        "termsAndConditions": "Terms of use",
        "privacyPolicy": "Privacy policy",
        "submitRequest": "Submit request",
        "acknowledged": "acknowledged and accepted",
        "requestForwarded": "The request has been forwarded.",
        "resetPassword": "Reset password",
        "passwordMismatch": "The password and its confirmation do not match!",
        "passwordComplexity": "Password complexity is insufficient. Please use a combination of letters (uppercase and lowercase), numbers, and special characters with a minimum length of 8 characters.",
        "passwordSetSuccess": "Your password has been set. You can now log in with your access data.",
        "passwordChangeSuccess": "Your password has been changed.",
        "errorOccurred": "An error occurred. Please try again later.",
        "passwordResetLinkSent": "If an account exists for the provided username, a link to reset the password has been sent to the associated email address.",
        "setPasswordTitle": "Set password",
        "setPasswordDescription": "Set a new password for your new account. You can then log in immediately using your username and the password set here.",
        "changePasswordTitle": "Change password",
        "newPasswordPlaceholder": "new password",
        "repeatPasswordPlaceholder": "repeat password",
        "termsAndConditionsRead1": "I have read the",
        "termsAndConditionsRead2": "acknowledged and accepted",
        "submitButton": "submit",
        "accessDenied": "Access denied!",
        "closeInfo": "Your requested changes are being reviewed.",
        "unlockColleague": "Unlock colleague",
        "sendChanges": "Send change requests",
        "firstname": "First name",
        "lastname": "Last name",
        "submitChangeRequest": "Send change requests",
        "accessNumber": "Access number",
        "changeRequestInProgress": "Your requested changes are being reviewed.",
        "iAccept": "I have read the",
        "haveRead": "acknowledged",
        "request": "request",
        "customerBase": "Customer base",
        "documentationHTML": "<h2>Documentation</h2><p>How to use the API can be found in our <a href=\"{frontendBase}/tibi-api/_/{namespace}/_/assets/redoc/\" target=\"_blank\">API documentation</a>.</p><p>The API is a REST API that you can address with any HTTP client.</p><p>For authentication, you need to insert the generated token into the HTTP header \"account-token-v1\".</p><h3>Example</h3><p><code>curl 'https://einfo.renzgroup.com/api/operation?limit=10&offset=0&sort=-insertTime'<br />&nbsp; -H \"accept: application/json\"<br />&nbsp; -H \"account-token-v1: TOKEN\"</code></p>"
    },
    "header": {
        "watchlist": "Watchlist",
        "processInformationSystem": "Process Information System",
        "more": "More",
        "switchAccount": "Switch account",
        "changeMasterData": "Change master data",
        "changePassword": "Change password",
        "template": "Template",
        "priceCalculation": "Price calculation",
        "addressBook": "Address book",
        "integrations": "Integrations",
        "token": "Token",
        "logout": "Log out",
        "login": "Log in",
        "copyrightPage": "Imprint",
        "logoutIn": "logout in {logoutInMinutes} min"
    },
    "notifications": {
        "successfulLogout": "You have successfully logged out of the system.",
        "failedLogout": "There was an error during your login. Please check your access credentials.",
        "resubmissionSuccessfullyUpdated": "Resubmission successfully updated.",
        "resubmissionSuccessfullyCreated": "Resubmission successfully created.",
        "changesGotSaved": "Changes were successfully updated."
    },
    "cart": {
        "cancel": "Cancel",
        "moveToCart": "Move to cart",
        "move": "shift",
        "referenceOfferNotFound": "Reference offer not found",
        "mapping": {
            "refNumber": "Reference number",
            "number": "Number",
            "endCustomerEmail": "End customer email",
            "endCustomerPhone": "End customer phone",
            "endCustomerAddress": {
                "label": "End customer address",
                "name1": "Name 1",
                "name2": "Name 2",
                "name3": "Name 3",
                "street": "Street",
                "country": "Country",
                "postcode": "Postal code",
                "city": "City"
            },
            "endCustomerVAT": "End customer VAT",
            "sumEndCustomerPrice": "End customer price",
            "sumEndCustomerPriceGross": "End customer price incl. VAT",
            "type": {
                "label": "Type",
                "1": "Offer",
                "2": "Order"
            },
            "source": {
                "label": "Source",
                "10": "Back Office",
                "20": "eConfig Pro (RIK)",
                "30": "eConfig (VR)",
                "31": "eAssist",
                "40": "RIT",
                "50": "eShop",
                "60": "eInfo",
                "80": "VU associated companies",
                "90": "LIK"
            },
            "statusSummary": {
                "label": "Status summary",
                "created": {
                    "label": "Created",
                    "0": "no",
                    "30": "in progress",
                    "100": "completed"
                },
                "emailed": {
                    "label": "Sent",
                    "0": "no",
                    "100": "yes"
                }
            },
            "orderedSummary": {
                "label": "Order summary",
                "ordered": {
                    "label": "Ordered",
                    "0": "no",
                    "100": "yes"
                },
                "orderedCount": "Ordered count"
            },
            "endCustomerFullAddress": {
                "label": "End customer full address",
                "id": "ID",
                "insertTime": "Insert time",
                "updateTime": "Update time",
                "dealerNumber": "Dealer number",
                "type": {
                    "label": "Type",
                    "person": "Person",
                    "company": "Company"
                },
                "vat": "VAT",
                "company": {
                    "label": "Company",
                    "name": "Name",
                    "vatId": "VAT ID",
                    "firstname": "First name",
                    "lastname": "Last name",
                    "paymentTerms": "Payment terms"
                },
                "person": {
                    "label": "Person",
                    "salutation": "Salutation",
                    "firstname": "First name",
                    "lastname": "Last name",
                    "parentCompany": "Parent company"
                },
                "location": {
                    "label": "Location",
                    "street": "Street",
                    "houseNumber": "House number",
                    "supplement": "Supplement",
                    "postcode": "Postal code",
                    "city": "City",
                    "country": "Country"
                },
                "contact": {
                    "label": "Contact",
                    "phone": "Phone",
                    "fax": "Fax",
                    "email": "Email",
                    "website": "Website"
                },
                "customerNumber": "Customer number",
                "priceCalculation": "Price calculation",
                "notModifyablePCalc": "Unchangeable price calculation",
                "deliveryAddress": {
                    "label": "Delivery address",
                    "salutation": "Salutation",
                    "name1": "Name 1",
                    "name2": "Name 2",
                    "name3": "Name 3",
                    "street": "Street",
                    "country": "Country",
                    "postcode": "Postal code",
                    "city": "City",
                    "phone": "Phone",
                    "fax": "Fax",
                    "email": "Email"
                }
            },
            "dealerNumber": "Dealer number",
            "inquiryDate": "Inquiry date",
            "inquiryNumber": "Inquiry number",
            "receiptDate": "Receipt date",
            "releaseDate": "Release date",
            "constructionProject": "Construction project",
            "constructionSite": "Construction site",
            "commission": "Commission",
            "residentialUnitsCount": "Number of residential units",
            "deliveryAddress": {
                "label": "Delivery address",
                "salutation": "Salutation",
                "name1": "Name 1",
                "name2": "Name 2",
                "name3": "Name 3",
                "street": "Street",
                "country": "Country",
                "postcode": "Postal code",
                "city": "City",
                "phone": "Phone",
                "fax": "Fax",
                "email": "Email"
            },
            "inquiryContact": {
                "label": "Clerk / Purchaser",
                "name": "Name"
            },
            "endCustomer": {
                "label": "End customer",
                "name": "Name"
            },
            "sumNetPrice": "Net merchandise value",
            "sumRetailPrice": "RRP",
            "clerk": {
                "label": "Clerk",
                "name": "Name",
                "email": "Email"
            },
            "internalClerk": {
                "label": "Internal clerk",
                "name": "Name"
            },
            "additionalPositions": {
                "label": "Additional items",
                "number": "Number",
                "service": "Service",
                "description": "Description",
                "netPrice": "Net price",
                "amount": "Quantity"
            },
            "documentTemplateTextContent": {
                "label": "Document template text content",
                "emailSubject": "Email subject",
                "emailBody": "Email body",
                "pdfIntro": "PDF introduction",
                "pdfOutro": "PDF outro",
                "preLetter": "Cover letter",
                "deliveryTime": "Delivery time",
                "paymentTerms": "Payment terms",
                "contact": {
                    "label": "Contact",
                    "useLoggedInUserAsDefault": "Use logged-in user as default",
                    "name": "Name",
                    "phone": "Phone",
                    "email": "Email",
                    "webUrl": "Website"
                }
            },
            "positions": {
                "label": "Items",
                "number": "Number",
                "type": "Type",
                "quantity": "Quantity",
                "orderQuantity": "Order quantity",
                "color": {
                    "label": "Color",
                    "code": "Color code",
                    "name": "Color name"
                },
                "additionalItems": {
                    "label": "Additional items",
                    "number": "Number",
                    "description": "Description",
                    "netPrice": "Net price",
                    "service": "Service",
                    "amount": "Quantity"
                },
                "state": {
                    "label": "Status",
                    "code": "Code",
                    "description": "Description",
                    "blockingIndicator": "Blocking indicator"
                },
                "delivery": {
                    "label": "Delivery",
                    "plannedDate": "Planned date",
                    "plannedDateNew": "New planned date",
                    "plannedWeek": "Planned week",
                    "actualDate": "Actual date",
                    "shippingCompany": "Shipping company code"
                },
                "origin": {
                    "label": "Origin",
                    "operationNumber": "Operation number",
                    "positionNumber": "Item number"
                },
                "residentialUnitsCount": "Number of residential units",
                "residentialUnitsCountTotal": "Total number of residential units",
                "rikNumber": "ECP number",
                "productGroup": "Product group",
                "modelGroup": "Model group",
                "installationType": "Installation type",
                "netPrice": "Net price",
                "endCustomerPrice": "End customer price",
                "endCustomerPriceGross": "End customer price incl. VAT",
                "retailPrice": "RRP",
                "alternativeTo": "Alternative to",
                "objectionPeriodEnd": "Objection period end date",
                "instructionsAvailable": "Installation instructions available",
                "specialCAD": "Special CAD",
                "items": {
                    "label": "Item elements",
                    "sequenceNumber": "Sequence number",
                    "amount": "Quantity",
                    "measureUnit": "Unit",
                    "number": "Order number",
                    "description": "Description"
                },
                "tracking": {
                    "label": "Tracking",
                    "sequenceNumber": "Sequence number",
                    "trackingNumber": "Tracking number",
                    "status": "Status",
                    "receiver": "Receiver"
                },
                "chargeable": "Chargeable",
                "chargeableReason": "Chargeable - Reason"
            }
        },
        "updated": "Cart {name} has been updated.",
        "updateFailedS": "Cart {name} could not be updated!",
        "inCartTooltip": "This offer is in the following carts:",
        "addToCartTooltip": "Add to cart",
        "dataTakeover": "Take over data from offer:",
        "dataOvertake": "Data takeover",
        "missingRequiredFields": "Please fill in all required fields!",
        "noDataAvailable": "No data available for takeover for this item.",
        "moveOffer": "Move offer to another cart",
        "moveOfferDisabled": "Offer cannot be moved to another cart because no other cart exists.",
        "copyOffer": "Copy offer to another cart",
        "copyOfferDisabled": "Offer cannot be copied to another cart because no other cart exists.",
        "deleteOffer": "Delete offer from cart",
        "moveOfferS": "Move offer",
        "deliveryAddress": "Delivery address",
        "created": "Cart {name} has been created.",
        "createFailed": "Cart {name} could not be created!",
        "cart": "Cart",
        "carts": "Carts",
        "copyOfferS": "Copy offer",
        "phoneNotificationChosen": "Phone notification was selected. Please fill in the fields for phone notification.",
        "cartDeleted": "Cart has been deleted.",
        "cartDeleteFailed": "Cart could not be deleted!",
        "orderSent": "Order has been sent.",
        "back": "Back",
        "addressUpdated": "Address has been updated.",
        "addressUpdateFailed": "Address could not be updated, please check your input!",
        "addressCreated": "Address was added to address book.",
        "addressCreateFailed": "Address could not be added to address book, please check your input!",
        "orderFailed": "Order could not be sent!",
        "updateFailed": "Cart could not be updated!",
        "costNotice": "Please note that costs may arise in the future. Currently, no costs are incurred.",
        "phoneNotificationRequested": "Phone notification requested?",
        "phoneNotification": "Notification phone",
        "editCart": "Edit cart",
        "deleteCart": "Delete cart",
        "cartIcon": {
            "inCartTooltip": "This offer is in the following carts: {foundInCarts}",
            "addMarkedItemsTooltip": "Add all marked items to cart",
            "addAllItemsTooltip": "Add all items to cart."
        },
        "updateSuccess": "Cart name has been changed.",
        "updateError": "Cart name could not be changed!",
        "createSuccess": "New cart has been created.",
        "createError": "New cart could not be created!",
        "createNewCartName": "New cart",
        "addCart": "Add cart",
        "createSuccessNotification": "Cart was successfully created.",
        "deleteSuccessNotification": "Cart was successfully deleted.",
        "updateSuccessNotification": "Cart was updated.",
        "updateErrorNotification": "Cart could not be updated.",
        "noCartsCreated": "No carts have been created yet.",
        "deleteModalTitle": "Delete cart",
        "deleteModalMessage": "Do you really want to delete the cart <strong>{cartName}</strong>?",
        "deleteButton": "Delete cart",
        "total": "Total",
        "amountPos": "Qty. items",
        "totalSum": "Total sum",
        "sendOrder": "Submit order",
        "saveData": "Data saved",
        "lookInAddressBook": "Search in address book",
        "deviatingShippingAddress": "Different shipping address",
        "homeAddress": "Home address",
        "shippingAddress": "Shipping address",
        "commission": "Commission",
        "commissionPlaceholder": "Enter commission",
        "constructionProject": "Construction project",
        "constructionProjectPlaceholder": "Enter construction project",
        "shipment": {
            "selectCalendarWeek": "Select calendar week",
            "dontShipBefore": "Do not deliver before CW:"
        },
        "legend": {
            "legend": "Legend",
            "operationCreated": "Operation created",
            "inProgress": "In progress",
            "offerCreated": "Offer created",
            "mandatoryField": "Required field"
        },
        "modals": {
            "copy": "Copy",
            "confirmDataTakeover": {
                "header": "Take over data",
                "body": "Should the data from offer {number} be taken over into the current cart?",
                "cancel": "Cancel",
                "confirm": "Take over data"
            },
            "deleteCartOperation": {
                "header": "Delete from cart",
                "body": "Do you really want to delete the offer {number} from the cart?",
                "cancel": "Cancel",
                "confirm": "Delete"
            },
            "addressUpdate": {
                "headerCreate": "Create address",
                "headerUpdate": "Update address",
                "bodyCreate": "Do you really want to create the address?",
                "bodyUpdate": "Do you really want to update the address?",
                "cancel": "Cancel",
                "confirmCreate": "Create",
                "confirmUpdate": "Update"
            },
            "moveCartOperation": "Move offer to another cart",
            "copyCartOperation": "Copy offer to carts",
            "orderCart": {
                "header": "Order cart",
                "body": "Do you really want to submit order {name}?",
                "cancel": "Cancel",
                "confirm": "Submit order"
            },
            "cartDeletion": {
                "header": "Delete cart",
                "body": "The cart is empty. Do you want to delete the cart {name}?",
                "cancel": "Cancel",
                "confirm": "Delete",
                "success": "Cart was deleted.",
                "error": "Cart could not be deleted!"
            }
        },
        "assignOperation": {
            "title": "Move offer to cart",
            "newCartLabel": "New cart",
            "tooltipAddToCart": "Add to cart",
            "cancelButtonLabel": "Cancel",
            "submitButtonLabel": "Add",
            "invalidCartNameTooltip": "Invalid cart name, check whether the name already exists and whether the cart has a valid name.",
            "noCartNameTooltip": "Please enter a cart name or select a cart.",
            "selectCartTooltip": "Add to cart"
        }
    },
    "tableColumns": {
        "source": {
            "label": "S",
            "tooltip": "Source"
        },
        "dealerNumber": {
            "label": "Cust-No.",
            "tooltip": "Dealer number"
        },
        "releaseDate": {
            "label": "Offer date"
        },
        "insertTimeOut1": {
            "label": "Offer date"
        },
        "insertTimeOut2": {
            "label": "OC date"
        },
        "number": {
            "labelOffer": "Offer no.",
            "labelOrder": "Order no."
        },
        "countOfPositions": {
            "label": "No. items",
            "tooltip": "Number of items"
        },
        "status": {
            "label": "Status"
        },
        "canceled": {
            "label": "Canceled"
        },
        "chargeable": {
            "label": "Chargeable",
            "tooltip": "Chargeable",
            "labelShort": "C"
        },
        "inquiryDate": {
            "label": "Inquiry date"
        },
        "releaseDateOrder": {
            "label": "Order date"
        },
        "endCustomerName": {
            "label": "Inquiry/Name"
        },
        "inquiryNumber": {
            "labelInquiry": "Inquiry no.",
            "labelOrder": "Order no."
        },
        "constructionProject": {
            "label": "Construction project"
        },
        "commission": {
            "label": "Commission"
        },
        "constructionSite": {
            "label": "Construction site"
        },
        "inquiryContact": {
            "label": "Clerk"
        },
        "lastUpdatedBy": {
            "label": "Last edited by"
        },
        "deliveryAddress": {
            "label": "Delivery address",
            "noDeliveryAddress": "No delivery address"
        },
        "endCustomerFullAddress": {
            "label": "End customer - Name",
            "address": "End customer address"
        },
        "residentialUnitsCount": {
            "label": "RU",
            "tooltip": "Residential units"
        },
        "sumNetPrice": {
            "label": "Total"
        },
        "followUpListOwner": {
            "label": "Watchlist owner"
        },
        "description": {
            "label": "Description"
        },
        "insertTime": {
            "label": "Created on"
        },
        "lastUsed": {
            "label": "Last used"
        }
    },
    "bookmarks": {
        "icon": {
            "editOwnResubmissionsOnly": "You can only edit your own resubmissions.",
            "removeFromWatchlist": "Remove from watchlist",
            "addToWatchlist": "Add to watchlist"
        },
        "addBookmarks": "Add bookmark",
        "addedBookmarks": "Bookmark added",
        "removeBookmarks": "Remove bookmark",
        "removedBookmarks": "Bookmark removed",
        "offers": "Offers",
        "orders": "Orders",
        "outgoingOffers": "Outgoing offers",
        "orderConfirmations": "Order confirmations",
        "bookmarks": "Watchlist",
        "myBookmarks": "My watchlist",
        "fullTextSearch": "Full-text search",
        "resetFilter": "Reset filter"
    },
    "login": {
        "successNotification": "You have successfully logged in to the eInfo system.",
        "failNotification": "An error occurred during login. Please check your credentials.",
        "mfaNotification": "Your login requires additional verification. Please enter the code sent to you via email.",
        "unknownErrorNotification": "Unknown error during login.",
        "enterMfaCode": "Please enter the code sent to you via email.",
        "usernamePlaceholder": "Username",
        "passwordPlaceholder": "Password",
        "submitButton": "Submit",
        "resetPassword": "Reset password",
        "requestAccess": "Request access",
        "login": "Log in",
        "code": "Code"
    },
    "integrations": {
        "configIntegrations": "Configurator Integration",
        "iframeRecommendation": "We recommend a minimum height of <b>800px</b> and a minimum width of <b>1000px</b> for embedding the iFrame.",
        "contactDataPrepopulation": "Pre-fill contact data (optional)",
        "useCustomerData": "You have the option to pre-fill the configurator using the master data of your logged-in customers.",
        "fieldsToPrepopulate": "The following fields can be pre-filled and appended via field names in the URL:",
        "dealerErrorHeader": "The dealer with number {dealerNumbers} is not fully configured for use in the configurator!",
        "dealerErrorInstructions": "Please check whether the offer template is correctly set up and enabled in the dealer account.",
        "preDefInsert": "Insert pre-filling in the code {additionalInfo}",
        "iframePreview": "and iFrame preview",
        "colorStyle": "Color style",
        "selectColorStyle": "Select color style",
        "backgroundColor": "Background color (optional)",
        "dealerCustomer": "Dealer customer",
        "dealerCustomers": "Dealer customers",
        "enterNumberOrName": "Enter number / name",
        "sourceCode": "Source code for your website",
        "preview": "Preview",
        "fieldName": "Field name",
        "importance": "Importance",
        "example": "Example",
        "noEntriesFound": "No entries found",
        "dealerIsntAvailable": "The dealer is not configured or enabled for use in the configurator.",
        "integrationsMap": {
            "firstname": "First name",
            "lastname": "Last name",
            "company": "Company",
            "city": "City",
            "street": "Street",
            "houseNumber": "House number",
            "postcode": "Postal code",
            "countryCode": "Country code",
            "email": "Email",
            "phone": "Phone"
        }
    },
    "operationsLegend": {
        "legendTitle": "Legend",
        "createdOperation": "Operation created",
        "inProgress": "In progress",
        "offerCreated": "Offer created",
        "cancellation": "Cancellation",
        "partialCancellation": "Partial cancellation",
        "statusDescriptionTitle": "Status description",
        "notStarted": "Not started",
        "inProcess": "In process",
        "delayed": "Delayed",
        "partlyDone": "Partially done",
        "completed": "Completed",
        "orderConfirmation": "Order confirmation",
        "objectionPeriod": "Objection period",
        "manufacture": "Manufacturing",
        "shipping": "Shipping",
        "delivery": "Delivery"
    },
    "followUp": {
        "onMyList": "on my list",
        "ownAndForeign": "You have {total} overdue follow-up{plural}. Of these, {ownCount} your own and {foreignCount} others'.",
        "onlyOwn": "You have {total} overdue follow-up{plural}.",
        "added": "Follow-up added",
        "removed": "Follow-up removed"
    },
    "operations": {
        "shareTransaction": "share this operation via link",
        "inquiryS": "Inquiry about {opNumber}",
        "inquiryContact": "Clerk",
        "protocol": "Protocol for {opNumber}",
        "email": "Email for {opNumber}",
        "offerType1": "{offerTabTitle_Type1} {opNumber}",
        "orderConfirmation": "Order confirmation {opNumber}",
        "orderS": "Order {opNumber}",
        "offerT": "Offer",
        "offer": "Make an inquiry about the entire offer",
        "linkSent": "The link was successfully sent to '{email}'.",
        "invalidEmail": "'{email}' is not a valid email address.",
        "showPositionDetails": "Show position details.",
        "incompleteOperation": "This operation has not been fully created yet.",
        "linkRegenerated": "The link has been regenerated. The old link is now invalid.",
        "linkDeactivated": "The link has been deactivated.",
        "linkCopied": "The link has been copied to the clipboard.",
        "linkCopyFailed": "The link could not be copied to the clipboard. {text}",
        "order": "Order",
        "share": "Share",
        "linkDescription": "With a link, other people (e.g. customers) can view this operation.",
        "noPriceInfo": "No prices or terms are visible to other people when accessing the link.",
        "copyLinkHint": "Here you can copy the link to the clipboard and forward it manually.",
        "copyLink": "Copy link",
        "regenerateLink": "Regenerate link",
        "regenerateLinkTooltip": "Generating a new link will invalidate the currently generated link.",
        "deactivateLink": "Deactivate link",
        "deactivateLinkTooltip": "Deactivating will invalidate the currently generated link. The recipient will no longer be able to access the operation.",
        "sendLinkByEmail": "Send link via email",
        "enterEmailHint": "Enter the desired recipient email address and click Send.",
        "emailPlaceholder": "Enter recipient email",
        "resetChanges": "This will reset all changes to the last saved version.",
        "inquiryTitle": "Inquiry about",
        "generalInquiry": "General inquiry",
        "complaint": "Complaint",
        "other": "Other",
        "inquirySent": "Your inquiry has been sent.",
        "operationNumber": "Operation {number}",
        "operationNotFound": "Operation {number} not found.",
        "position": "Position",
        "topic": "Topic",
        "selectTopic": "Select topic",
        "message": "Message",
        "submit": "Submit",
        "source": "Source",
        "customerNumber": "Cust. No.",
        "orderNumber": "Order No.",
        "outbound": "Outbound",
        "origin": "Origin",
        "numberOfPositions": "No. of items",
        "status": "Status",
        "cancellation": "Cancellation",
        "orderDate": "Order date",
        "endCustomer": "End customer",
        "inquiryName": "Inquiry/Name",
        "inquiryNumber": "Inquiry No.",
        "constructionProject": "Construction project",
        "commission": "Commission",
        "constructionSite": "Construction site",
        "orderContact": "Buyer",
        "we": "RU",
        "residentialUnits": "Residential units",
        "sum": "Total",
        "inquiry": "Inquiry",
        "inquiryPlace": "Submit inquiry",
        "inquiryOrder": "Make an inquiry about the entire order",
        "deliveryAddress": "Delivery address",
        "lastUpdatedBy": "Last edited by",
        "openCustomerOrderConfirmation": "Open customer order confirmation",
        "openOriginalOrder": "Open original order",
        "offerDate": "Offer date",
        "offerNumber": "Offer No.",
        "openCustomerOffer": "Open customer offer",
        "openOriginalOffer": "Open original offer",
        "inquiryDate": "Inquiry date",
        "duplicateAndEdit": "Duplicate <br/> and edit",
        "head": {
            "origin": "Origin",
            "customerNumber": "Cust. No.",
            "offerDate": "Offer date",
            "orderConfirmationDate": "Order<br/>confirmation date",
            "offerNr": "Offer No.",
            "orderNr": "Order No.",
            "source": "Source",
            "openOriginalOffer": "Open original offer",
            "openOriginalOrder": "Open original order",
            "initialOffer": "Initial offer",
            "noReferenceFound": "No reference found",
            "amountOfPositions": "No. of items",
            "status": "Status",
            "inquiryDate": "Inquiry date",
            "editedLast": "Last edited<br /> by",
            "clerk": "Clerk",
            "yourReference": "Your reference",
            "constructionProject": "Construction project",
            "commission": "Commission"
        }
    },
    "operationsOut": {
        "entryNotFound": "Entry not found.",
        "clickForMoreInfo": "Click entry for more info",
        "resetFilter": "Reset filter",
        "filter": "Filter",
        "tableView": "Table view",
        "gridView": "Grid view",
        "orderConfirmation": "Order confirmation",
        "address": {
            "applyPriceGroup": "Apply price group?",
            "noPriceGroup": "The address has no price group assigned.",
            "resetGlobal": "Do you want to reset the price calculation to the global setting?",
            "partnerCompany": "Company of the contact person",
            "selectedAddress": "Your selected address",
            "priceGroupApplied": "has price group {priceGroup} assigned. Do you want to apply this to {documentType}?",
            "currentOffer": "the current offer",
            "currentOrderConfirmation": "the current order confirmation",
            "no": "no",
            "yes": "yes",
            "endCustomerAddress": "End customer address",
            "searchInAddressBook": "Search in address book",
            "saveData": "Data saved"
        }
    },
    "positions": {
        "specialRequestNoCharge": "Special request to Renz employee – possibly no compensation",
        "sequenceNumber": "Seq. No.",
        "quantity": "Quantity",
        "unit": "Unit",
        "articleNumber": "Article number",
        "description": "Description",
        "offerNumber": "Offer No.",
        "orderNumber": "Order No.",
        "position": "Position",
        "alternativeTo": "Alternative to",
        "fileAttachements": "File attachments",
        "linkedIncomingOperations": "Linked incoming operations",
        "linkedOutgoingOperations": "Linked outgoing operations",
        "texts": "Texts",
        "positionCoverLetter": "Position cover letter",
        "positionsTexts": "Position texts",
        "origin": "O.",
        "source": "Source",
        "customerNumber": "Cust. No.",
        "attachement": "Link",
        "amountOfPositions": "No. of items",
        "status": "Status",
        "date": "Date",
        "inquiryOrOrderNumber": "Inquiry/Order No.",
        "commission": "Commission",
        "constructionProject": "Construction project",
        "constructionSite": "Construction site",
        "residentialUnits": "RU",
        "residentialUnitsCountTooltip": "Residential units",
        "sum": "Total",
        "noAttachedOperations": "No linked operations",
        "net": "Net",
        "gross": "Gross",
        "withoutAlternativePositions": "Without alternative positions",
        "assemblyInstructionSent": "The requested assembly instructions will be sent to you via email and will also be available in eInfo within the next few minutes.",
        "errorOccurred": "An error occurred! Please try again later.",
        "requestAssemblyInstruction": "Request assembly instructions",
        "enterEmailPrompt": "Please provide an email address to send the assembly instructions to.",
        "sendAssemblyInstructionTo": "Send assembly instructions to",
        "submit": "Submit",
        "requestAssemblyInstructionBreak": "Request<br />assembly instructions",
        "deleteFromOperation": "Delete from operation",
        "confirmDeletePosition": "Do you really want to delete position \"<strong>{number}</strong>\" from the operation?",
        "deleteOperation": "Delete operation",
        "confirmDeleteLastPosition": "This is the last position. Are you sure you want to delete the operation from the cart?",
        "restorePosition": "Restore position",
        "confirmRestorePosition": "Do you really want to restore position \"<strong>{number}</strong>\"?",
        "marginWarning": "Your selling price is lower than your purchase price.",
        "image": "Image",
        "positionShort": "Pos.",
        "quantityShort": "Qty.",
        "chargeable": "Chargeable",
        "productGroup": "Product group",
        "modelGroup": "Model group",
        "color": "Color",
        "cancellation": "Cancellation",
        "noCancellation": "No cancellation",
        "deliveryDateFromFactory": "Delivery date ex works",
        "tracking": "Tracking",
        "ecpNumber": "ECP number",
        "residentialUnitsShort": "RU",
        "infoToAgent": "Info to clerk",
        "unitPrice": "Unit price",
        "actions": "Actions",
        "packagingAndShipping": "Packaging & shipping",
        "packagingAndShippingDescription": "This amount is charged for packaging and shipping.",
        "noPreviousEntry": "No previous entry",
        "alternativeToPosition": "Alternative to position {number}",
        "previousValue": "Previous value",
        "amount": "Amount",
        "sellingPrice": "SP",
        "purchasePrice": "PP",
        "showPositionDetails": "Show position details.",
        "inquiry": "Inquiry",
        "inquiryForPosition": "Submit inquiry for this position",
        "deletePosition": "Delete position",
        "delete": "Delete",
        "recreate": "Restore",
        "recreatePosition": "Restore position",
        "noColorSpecification": "No color specification",
        "addAdditionalService": "Add additional service",
        "RRP": "RRP",
        "endcustomer": "End customer",
        "margin": "Margin"
    },
    "priceCalculation": {
        "priceCalculation": "Price calculation",
        "globalPricegroup": "global price group",
        "dealerNr": "Dealer No.",
        "manualInput": "Manual input"
    },
    "address": {
        "deliveryEqualsCompany": "delivery address is the same as company address",
        "deliveryUnequalsCompany": "delivery address is different from company address",
        "customerNumberAlreadyTaken": "Customer number already taken.",
        "decideCompAndShipAddress": "Please decide whether the company address is the same as the shipping address.",
        "fillOutMandatoryFields": "Please fill out all required fields!",
        "editAddress": "Edit address",
        "addPersonSuccess": "Contact person was added.",
        "addAddressSuccess": "New address was successfully created.",
        "addPersonError": "Error while adding the contact person.",
        "addAddressError": "Error while creating the address.",
        "closeAddress": "Close address",
        "unsavedChanges": "You have unsaved changes, are you sure you want to close the form?",
        "addressBook": "Address book",
        "contactPerson": "Contact person",
        "firstName": "First name",
        "lastName": "Last name",
        "companyName": "Company name",
        "vatId": "VAT ID",
        "company2OrAdditionalAddress": "Company 2 / Address supplement",
        "noChangeToGlobalTaxRate": "no change to global tax rate",
        "postalCode": "Postal code",
        "vat": "VAT",
        "phone": "Phone",
        "paymentTerms": "Payment terms",
        "fax": "Fax",
        "email": "Email",
        "website": "Website",
        "contactPersonName": "CONTACT PERSON (LAST NAME, FIRST NAME)",
        "assignedPriceGroup": "Assigned price group",
        "contactPersonSalutation": "CONTACT PERSON SALUTATION",
        "edit": "Edit address",
        "delete": "Delete address",
        "createSuccess": "New address was successfully created.",
        "createError": "Error while creating the address.",
        "freeSearch": "Free search",
        "enterSearchTerm": "Enter search term",
        "type": "Type",
        "company": "Company",
        "salutation": "Salutation",
        "firstname": "First name",
        "lastname": "Last name",
        "street": "Street",
        "houseNumber": "House No.",
        "supplement": "Address supplement",
        "postcode": "Postal code",
        "city": "City",
        "country": "Country",
        "customerNumber": "Cust. No.",
        "typeTooltipCompany": "Company",
        "typeTooltipContactPerson": "Contact person",
        "setNewAddress": "Create new address",
        "setNewEntry": "Create new entry",
        "entry": "Record",
        "editEntry": "Edit entry",
        "deleteContact": "Delete contact",
        "saveData": "Data saved",
        "reset": "⟳ reset",
        "notModified": "Address was not modified.",
        "closeHeader": "Close address",
        "unsavedChangesWarning": "You have unsaved changes, are you sure you want to close the form?",
        "contactDeletedSuccess": "Contact person was successfully deleted.",
        "resetChangesInfo": "This will reset all changes to the last saved version.",
        "deleteError": "Address could not be deleted!",
        "multipleDeleteSuccess": "{successfulDeletes} contact persons and one address were successfully deleted.",
        "partialDeleteError": "Some addresses could not be deleted!",
        "unexpectedError": "An unexpected error occurred!",
        "removeContactHeader": "Remove contact person",
        "deleteEntryHeader": "Delete entry",
        "removeContactConfirm": "Do you really want to remove the contact person?",
        "deleteContactConfirm": "Do you really want to delete the contact from the address book? All assigned contact persons will also be deleted.",
        "cancelButton": "Cancel",
        "removeButton": "Remove",
        "deleteButton": "Delete",
        "customerNumberLabel": "(Customer No.: {customerNumber})",
        "dealerNumberLabel": "(Dealer No.: {dealerNumber})",
        "dealerNr": "Dealer No.",
        "manualEntry": "Manual entry",
        "newContact": "New contact person",
        "fillRequiredFields": "Please fill out all required fields!"
    },
    "components": {
        "additionalServices": {
            "addService": "Add additional service",
            "deleteService": "Delete additional service",
            "amount": "Quantity",
            "service": "Service",
            "description": "Description",
            "price": "Price (€)",
            "salesPrice": "SP:",
            "serviceToPosition": "Service for position"
        },
        "additionalPosition": {
            "additionalPosition": "Additional item",
            "headingInPdf": "Heading in PDF",
            "addAdditionalPosition": "Add additional item",
            "additionalPositionAdd": "Add additional item"
        },
        "operationsEmail": {
            "recipient": "Recipient",
            "cc": "CC",
            "bcc": "BCC",
            "subject": "Subject",
            "message": "Message",
            "sendOfferSubject": "Customer offer {number}",
            "sendOrderConfirmationSubject": "Order confirmation {number}",
            "sendOfferMessage": "Dear Sir or Madam,\nattached you will find the non-binding offer for the requested items.\n\nBest regards,\n{firstName} {lastName} ({email})",
            "sendOrderConfirmationMessage": "Dear Sir or Madam,\nattached you will find the order confirmation.\n\nBest regards,\n{firstName} {lastName} ({email})",
            "attachment": "Attachment",
            "sendButton": "Send",
            "offerSentNotification": "The offer has been sent.",
            "orderConfirmationSentNotification": "The order confirmation has been sent.",
            "errorNotification": "An error occurred. Please try again later.",
            "offerCouldNotBeSent": "Offer could not be saved"
        },
        "operationDetails": {
            "manualPriceGroup": "Manual entry",
            "globalPriceGroup": "Global price group",
            "dealerNumber": "Dealer No.",
            "offerTemplate": "Offer template",
            "orderConfirmationTemplate": "Order confirmation template",
            "couldNotBeCreated": " could not be created",
            "offer": "Offer",
            "orderConfirmation": "Order confirmation",
            "isNotCompleted": " is not yet completed, please check whether a valid template has been set.",
            "wasSuccessfullySaved": " was successfully saved.",
            "offerCouldNotBeSaved": "Offer could not be saved",
            "wasSuccessfullyCreated": " was successfully created.",
            "saveToGeneratePDF": "Save the document to generate the PDF.",
            "selectAtLeastOnePosition": "Please select at least one position",
            "markedPositionsToCart": "marked positions to cart",
            "convertToCustomerOffer": "to customer offer",
            "convertToOrderConfirmation": "to order confirmation",
            "transformTo": "convert to",
            "sendOfferToCustomer": "Send offer <br /> to customer",
            "createOrderConfirmationAndEdit": "Create order confirmation <br /> and edit",
            "sendOrderConfirmationToCustomer": "Send order confirmation <br /> to customer",
            "offerChanged": "Offer has been changed, please save!",
            "noCorrespondingOrder": "No corresponding order available, please wait until the order is available in the Renz system!",
            "orderCanceled": "Order has been canceled.",
            "allPositionsCanceled": "All relevant positions in the order have been canceled.",
            "orderConfirmationChanged": "Order confirmation has been changed, please save!",
            "orderConfirmationNotComplete": "Order confirmation is not yet completed.",
            "offerAlreadySent": "Offer has already been sent to the customer",
            "orderConfirmationAlreadySent": "Order confirmation has already been sent to the customer",
            "orderConfirmationTemplateError": "Order confirmation template could not be created: ",
            "offerNotChanged": "Offer has not been changed!",
            "orderConfirmationNotChanged": "Order confirmation has not been changed!",
            "offerReset": "Reset offer to last saved version",
            "orderConfirmationReset": "Reset order confirmation to last saved version",
            "orderNotComplete": "Order is not yet completed.",
            "offerNotCompleted": "Offer is not yet completed, please check if the PDF exists. If not, ensure a valid template is available and save again!",
            "templateNotAvailable": "Neither the dealer number assigned to the operation nor your account has a template assigned.",
            "offerDataInherited": "The settings from the original offer(s) of the respective positions will be inherited.",
            "invalid": "invalid",
            "dataFromIncomingOrder": "The data from the incoming order will be used."
        },
        "table": {
            "changesInOperations": "Changes in operations",
            "fieldName": "Field name",
            "previousValue": "Previous value",
            "currentValue": "Current value",
            "watchlist": "Watchlist",
            "offerNumber": "Offer number",
            "transationStemsFrom": "The operation originates from an outbound offer",
            "offerGotChanged": "The offer {offerNumber} was changed externally, the revised version is shown here.",
            "noCurrentEntry": "No current entry",
            "noEarlierEntry": "No previous entry",
            "fields": {
                "attachmentField": {
                    "offer": "Offer",
                    "orderConfirmation": "Order confirmation",
                    "invoice": "Invoice",
                    "deliveryNote": "Delivery note",
                    "twoDOverall": "2D overview image",
                    "twoDDetail1": "2D detail section 1",
                    "twoDDetail2": "2D detail section 2",
                    "twoDImage": "2D image",
                    "threeDImage": "3D image",
                    "assemblyInstruction": "Assembly instructions",
                    "dxfFile": "DXF file"
                },
                "cancellation": {
                    "none": "no cancellation",
                    "full": "all items canceled",
                    "partial": "partial cancellation"
                },
                "trackingList": {
                    "delivered": "delivered",
                    "inDelivery": "in delivery",
                    "inTransit": "in transit",
                    "noData": "no data available",
                    "externalLink": "external link to {shippingCompany}",
                    "noTrackingLink": "no tracking link available",
                    "shippingCompany": "Shipping company: {shippingCompany}",
                    "receipt": "Receipt: {receiver}"
                },
                "trackingField": {
                    "trackingLabel": "Tracking",
                    "deliveredStatus": "{deliveredCount} of {count} delivered",
                    "showDetails": "Show details",
                    "notAvailable": "not available"
                },
                "status": {
                    "orderConfirmation": "Order confirmation",
                    "shipping": "Shipping",
                    "manufacture": "Manufacturing",
                    "offerCreated": "Offer created",
                    "offerInProgress": "Offer in progress",
                    "offerEmailSent": "Offer email {emailDetails} sent",
                    "noOfferEmailSent": "No offer email sent yet",
                    "emailDetails": "last sent to {recipient} on {timestamp}",
                    "orderConfirmationEmailSent": "Order confirmation email {emailDetails} sent",
                    "noOrderConfirmationEmailSent": "No order confirmation email sent yet",
                    "inConfirmCount": "{count} item(s) in processing",
                    "orderConfirmed": "Order confirmed",
                    "orderInProgress": "Order in progress",
                    "inObjectionPeriod": "{count} item(s) within objection period",
                    "objectionPeriodExpiredForSome": "Objection period expired for {count} item(s)",
                    "objectionPeriodExpired": "Objection period expired",
                    "objectionPeriodAfterConfirmation": "Objection period starts after order confirmation",
                    "inManufacture": "{count} item(s) in production",
                    "manufactureCompleted": "Production completed",
                    "noItemsInManufacture": "No items in production",
                    "inReadyToShip": "{count} item(s) ready for shipping",
                    "readyToShipCompleted": "Ready for shipping completed",
                    "noItemsReadyToShip": "No items ready for shipping",
                    "inShipment": "{count} item(s) shipped",
                    "delivered": "{count} item(s) delivered",
                    "noItemsInShipment": "No items in shipment",
                    "missingTracking": "No (complete) tracking information available.",
                    "orderedMultiple": "Ordered {count} times.",
                    "notOrdered": "Not ordered yet.",
                    "fullyOrdered": "Fully ordered",
                    "orderedCount": "{count} item(s) ordered",
                    "outboundOfferCreated": "Outbound offer created",
                    "noOutboundOfferCreated": "No outbound offer created",
                    "orderConfirmationCreated": "Order confirmation created",
                    "noOrderConfirmationCreated": "No order confirmation created",
                    "operationStatusUpdated": "Status of operation {operationNumber} set to {statusLabel} and note updated.",
                    "operationStatusOnlyUpdated": "Status of operation {operationNumber} set to {statusLabel}.",
                    "operationNoteUpdated": "Note of operation {operationNumber} updated.",
                    "noPermissionToEditStatus": "You do not have permission to edit the status",
                    "defaultFirstName": "My first name",
                    "defaultLastName": "My last name",
                    "operationTracking": "Operation tracking for {operationNumber}",
                    "status": "Status",
                    "notes": "Notes",
                    "insertTimestampLine": "Insert timestamp line",
                    "noNotesAvailable": "No notes available",
                    "clickIconToMakeChanges": "Click the icon to make changes",
                    "inObjectionPeriodUntil": "Item in objection period until {date}",
                    "objectionPeriodExpiredOn": "Objection period expired{dateInfo}",
                    "dateOn": " on {date}",
                    "positionInManufacture": "Item in production",
                    "manufactureNotStarted": "Production not started",
                    "positionDelivered": "Item delivered",
                    "positionShippedNoTracking": "Item shipped\n\nNo tracking information available.",
                    "positionShipped": "Item shipped",
                    "positionNotShipped": "Item not shipped yet",
                    "positionReadyToShip": "Item ready to ship",
                    "noPositionsInShipping": "No items in shipping"
                },
                "number": {
                    "offerNumber": "Offer / Number {operationNumber}",
                    "orderNumber": "Order / Number {operationNumber}",
                    "positionNumber": "\nItem {positionNumber}"
                },
                "chargeableField": {
                    "CAD": "Item is now Special CAD",
                    "NTF": "Item is Net Fixed",
                    "BTF": "Item is Gross Fixed",
                    "GNE": "Reason not identifiable",
                    "CPY": "Initial value from copy process in BO (only appears if source = BO)",
                    "SBE": "Added by clerk (new item)",
                    "BNI": "Consultation with RENZ ID clerk",
                    "BNA": "Bonuses at header level deactivated => not eligible for RIK compensation",
                    "SW": "Customer provided special request",
                    "SBO": "Edited later by clerk",
                    "SBA": "Edited later by clerk",
                    "SBR": "Removed due to manual discount editing",
                    "SHO": "Entered via eConfig",
                    "WVU": "Goods traffic VU (affiliated companies)",
                    "QNR": "RIT order, source not RIK-compensable",
                    "chargeable": "Item is compensable.",
                    "notChargeable": "Item is not compensable",
                    "reason": "\n\n{reason}",
                    "notChargeableOperation": "Operation not compensable. {reasonsText}",
                    "partiallyChargeable": "{chargeableCount} of {totalCount} item(s) are compensable. {reasonsText}",
                    "fullyChargeable": "All items in the operation are compensable"
                }
            }
        },
        "priceWizard": {
            "priceWizard": "Price Wizard",
            "showPricewizard": "Show Price Wizard",
            "applyConfirmation": "Apply confirmation",
            "applyPriceGroupPrompt": "Do you want to apply the price group to the entire operation or just this item?",
            "applyRestricted": "apply to item",
            "applyEntireOperation": "apply to entire operation",
            "applyMarginWarning": "Your selling price is lower than your purchase price. Are you sure you want to continue?",
            "resetConfirmation": "This will reset all changes to the last saved version.",
            "priceGroupNotModified": "Price group was not modified.",
            "sellingPrice": "Selling price",
            "inputInEUR": "Input in EUR",
            "additionalPositionNumber": "Additional item No.",
            "quantity": "Qty.",
            "RRP": "RRP",
            "sale": "Discount",
            "discount": "Discount",
            "inputInPercent": "Input in %",
            "specificationInEur": "Input in EUR",
            "subtotal": "Subtotal",
            "surcharge": "Surcharge",
            "currentPurchasePrice": "Current purchase price",
            "difference": "Difference",
            "originalPurchasePrice": "Original purchase price",
            "basisForCalculations": "(Basis for calculations)",
            "purchasePrice": "Purchase price",
            "entirePriceGroup": "Entire price group",
            "selectPriceGroup": "Select price group",
            "showDiscountPDFs": "Show discount in offer & order confirmation PDFs",
            "costType": "Cost type",
            "net": "Net",
            "gross": "Gross",
            "percentageInput": "Input in %",
            "closeIcon": "Close",
            "searchIcon": "Search",
            "editEndcustomerAddress": "Edit end customer address"
        },
        "richtext": {
            "bold": "Bold",
            "italic": "Italic",
            "underline": "Underline",
            "strike": "Strikethrough",
            "align": "Alignment",
            "blockquote": "Quote",
            "code_block": "Code",
            "list": "List",
            "color": "Text color",
            "background": "Background color",
            "image": "Insert image",
            "link": "Insert link",
            "clean": "Remove formatting",
            "priceGroupNotModified": "Price group was not modified."
        },
        "datepicker": {
            "days": [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ],
            "daysShort": [
                "Su",
                "Mo",
                "Tu",
                "We",
                "Th",
                "Fr",
                "Sa"
            ],
            "daysMin": [
                "Su",
                "Mo",
                "Tu",
                "We",
                "Th",
                "Fr",
                "Sa"
            ],
            "months": [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ],
            "monthsShort": [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            "today": "Today",
            "clear": "Clear",
            "titleFormat": "MM y",
            "format": "dd.mm.yyyy"
        },
        "overlay": {
            "closeOffer": "Close offer",
            "unsavedChanges": "You have unsaved changes. Are you sure you want to close the offer?"
        },
        "followUp": {
            "removeResubmissionDate": "Remove follow-up date",
            "setResubmissionDate": "Set follow-up date",
            "onlyEditResubmissions": "You can only edit your own follow-ups."
        },
        "documentTemplate": {
            "template": "Template",
            "offerTemplate": "Offer template",
            "orderConfirmationTemplate": "Order confirmation template",
            "offerTemplateGotSaved": "Offer template saved successfully.",
            "filesAllowed": "Only png and jpg/jpeg files are allowed.",
            "resetToDefault": "Reset to default",
            "letterPaper": "Letterhead",
            "defineLayoutThroughBGImages": "Define layout using background image(s)",
            "defineLayoutThroughLogo": "Define layout using logo file",
            "logoPosition": "Logo position",
            "verticalOrientation": "Vertical alignment",
            "horizontalOrientation": "Horizontal alignment",
            "verticalDisplacement": "Vertical displacement",
            "horizontalDisplacement": "Horizontal displacement",
            "noLogoAvailable": "No logo available yet",
            "deleteFile": "Delete file",
            "footer": "Footer",
            "noFooterAvailable": "No footer available yet",
            "firstPage": "First page",
            "noTemplateAvailable": "No template available yet",
            "templateNotModified": "Template was not modified.",
            "subsequentPages": "Subsequent pages",
            "margins": "Page margins",
            "top": "Top",
            "right": "Right",
            "bottom": "Bottom",
            "left": "Left",
            "forSubsequentPages": "on subsequent pages",
            "preview": "Preview",
            "mandatoryField": "Required field",
            "textContent": "Text content",
            "contact": "Contact person",
            "defaultContactPerson": "By default, the logged-in user is used as contact. You can disable this in \"Edit Template\".",
            "displayedContactPerson": "Displayed contact person in template header*",
            "eMailOfContact": "Email of contact person*",
            "useLoggedInUserAsContact": "Use logged-in user as contact person.",
            "telephoneOfContact": "Phone number of contact person*",
            "currentLoggedInUser": "Currently logged-in user:",
            "emailContent": "Email text",
            "emailSubject": "Email subject*",
            "subjectLine": "This is a subject line",
            "emailBody": "Email body",
            "pdfContent": "PDF texts",
            "introductionText": "Introduction text",
            "introContent": "This is the introduction text",
            "originalCoverLetter": "Original cover letter",
            "closingNote": "Closing note (shown after the item list)",
            "closingText": "This is the closing text",
            "coverLetter": "Cover letter",
            "deliveryTimeAndPaymentTerms": "Delivery time and payment terms*",
            "deliveryTime": "Delivery time",
            "paymentTermsDescription": "Description of payment terms",
            "emailBodyPlaceholder": "This is the cover letter",
            "paymentTerms": "Payment terms*",
            "editTemplate": "Edit template"
        },
        "pcalc": {
            "originType": "Origin type",
            "uvp": "RRP",
            "markupOnPurchasePrice": "Markup on purchase price",
            "discountOnRRP": "Discount on RRP",
            "minMarginOnPurchasePrice": "Minimum margin on purchase price",
            "addPriceGroup": "Add price group",
            "priceCalculation": "Price calculation",
            "globalPriceCalculation": "Global price calculation",
            "priceGroups": "Price groups",
            "updateSuccess": "Changes saved successfully.",
            "updateError": "Changes could not be saved.",
            "createSuccess": "Price calculation saved successfully.",
            "createError": "Price calculation could not be saved.",
            "deleteSuccess": "Price calculation deleted successfully.",
            "deleteError": "Price calculation could not be deleted.",
            "defaultCalculation": "Default calculation",
            "groupNamePlaceholder": "Group name",
            "editGroupName": "Edit group name",
            "deleteGroup": "Delete group",
            "resetTooltip": "This resets all changes to the last saved version.",
            "reset": "Reset",
            "invalid": "Invalid",
            "notModified": "Price group was not modified.",
            "validity": "Validity",
            "daysValidPlaceholder": "e.g. 14",
            "days": "Days",
            "fixedDates": "Fixed dates",
            "datePlaceholder": "From",
            "internalComment": "Internal comment",
            "commentNote": "(will not appear on printouts)",
            "commentPlaceholder": "Your comment on the date",
            "addFixedDate": "Add fixed date",
            "exceptionRule": "Exception rule",
            "exceptionRules": "Exception rules",
            "youCanIndivualize": "You can individualize your calculation using the fields 'Attribute', 'Comparison operator', and 'Search value' (multiple values possible).",
            "processedTopBottom": "Rules are processed from top to bottom.",
            "filter": "Filter",
            "addExceptionRule": "Add exception rule",
            "exceptionRuleTitle": "Exception rule title",
            "removeFilter": "Remove filter",
            "comparisonOperator": "Comparison operator",
            "installationType": "Installation type",
            "netPrice": "Net price",
            "residentialUnitsCount": "Residential units",
            "residentialUnitsCountTotal": "Total residential units",
            "productGroup": "Product group",
            "modelGroup": "Model group",
            "equalsExample": "Equals (e.g., 5 = 5)",
            "notEqualsExample": "Not equals (e.g., 5 != 3)",
            "greaterExample": "Greater than (e.g., 5 > 3)",
            "lessExample": "Less than (e.g., 3 < 5)",
            "greaterOrEqualExample": "Greater or equal (e.g., 5 >= 5)",
            "lessOrEqualExample": "Less or equal (e.g., 3 <= 5)",
            "attribute": "Attribute"
        },
        "pcalcGroup": {
            "priceGroup": "Price group",
            "globalPriceGroup": "Global price group",
            "dealerNr": "Dealer No.",
            "selectPriceGroup": "Select price group",
            "manualInput": "Manual input",
            "activePriceGroup": "Active price group",
            "changePriceGroup": "Change price group",
            "applyPriceGroup": "Apply price group",
            "inclusive": "incl.",
            "vat": "VAT",
            "gotApplied": "Price group applied successfully."
        },
        "noOffer": "No Offer",
        "operationsFilter": {
            "all": "all",
            "taskSent": "Order confirmation sent",
            "offerSent": "Offer sent",
            "allSources": "All sources",
            "user_status": "User status",
            "internal_status": "Internal status",
            "undefined": "All statuses",
            "inProgress": "In progress",
            "created": "Offer created",
            "outOfferCreated": "Outbound offer created",
            "ordered": "Ordered",
            "open_dealer": "Open",
            "lost_dealer": "Lost",
            "won_dealer": "Won",
            "waitingForResponse_dealer": "Waiting for response",
            "followup_dealer": "Follow-up",
            "locked_dealer": "Locked",
            "open_internal": "Open",
            "lost_internal": "Lost",
            "won_internal": "Won",
            "waitingForResponse_internal": "Waiting for response",
            "followup_internal": "Follow-up",
            "locked_internal": "Locked",
            "confirmed": "Order confirmation",
            "objectionPeriod": "Objection period",
            "inObjectionPeriod": "In objection period",
            "delayed": "Delayed",
            "manufactured": "In production",
            "readyToShip": "Ready for shipping",
            "inShipment": "Shipped",
            "delivered": "Delivered",
            "canceled": "Canceled",
            "applyFilter": "Apply filter",
            "resetFilter": "Reset filter",
            "agent": "Clerk",
            "selectAgent": "Select clerk",
            "representative1": "Representative 1",
            "selectRepresentative": "Select representative",
            "selectModelGroup": "Select model group",
            "modelGroup": "Model group",
            "installationType": "Installation type",
            "selectInstallationType": "Select installation type",
            "residentialUnits": "Residential units",
            "unitPrice": "Unit price",
            "advancedSearch": "Advanced search",
            "dealerCustomers": "Dealer customers",
            "enterNumberOrName": "Enter number / name",
            "until": "until",
            "filterTimeRange": "Filter by time range",
            "from": "from",
            "freeSearch": "Free search",
            "origin": "Origin",
            "selectOrigin": "Select origin",
            "selectStatus": "Select status",
            "status": "Status",
            "filter": "Filter"
        },
        "operationProtocol": {
            "protocolForOffer": "Protocol for offer {number}",
            "noProtocol": "This offer has no protocol yet.",
            "timestamp": "Timestamp",
            "action": "Action",
            "editor": "Edited by",
            "details": "Details",
            "legend": "Legend",
            "emailSent": "Email sent",
            "added": "Added",
            "created": "Created",
            "edited": "Edited",
            "close": "Close",
            "protocol": "Protocol",
            "operationChanges": "Operation changes",
            "fieldName": "Field name",
            "previousValue": "Previous value",
            "currentValue": "Current value",
            "noPreviousEntry": "No previous entry",
            "noCurrentEntry": "No current entry",
            "creationOrderConfirmation": "creation of the order confirmation",
            "creationOffer": "creation of the offer",
            "processingOrderConfirmation": "processing of the order confirmation",
            "processingOffer": "processing of the offer"
        },
        "date": {
            "dateDeleteValidationModal": {
                "question": "Do you really want to remove the date?",
                "cancelButton": "Cancel",
                "deleteButton": "Yes"
            },
            "followUpDeleteValidationModal": {
                "question": "Do you really want to remove the operation from the watchlist?",
                "cancelButton": "Cancel",
                "deleteButton": "Yes"
            }
        }
    },
    "config": {
        "open": "Open",
        "lost": "Lost",
        "won": "Won",
        "locked": "Locked",
        "waitingForResponse": "Waiting for response",
        "followup": "Follow-up",
        "country": {
            "DE": "Germany",
            "AT": "Austria",
            "SE": "Sweden",
            "LU": "Luxembourg",
            "BE": "Belgium"
        },
        "hints": {
            "placeholderHint": "You can insert the following placeholders:<br />[Number]<br />[Company]<br />[First name]<br />[Last name]<br />[Project]<br />[Commission]",
            "imageFormatHint": "Image format should be .jpg or .png. The optimal resolution is 2480x3508 pixels. Other sizes are possible, and the app will scale accordingly. However, display quality may suffer.",
            "imageSimpleFormatHint": "Image format should be .jpg or .png. The optimal resolution for the logo is 1240x680 pixels. For the footer, 2480x240 pixels at approx. 3 cm height is ideal. Other sizes are possible, but may affect display quality."
        },
        "shippingCompanies": {
            "1003": "DPD",
            "1004": "Spedition Kirchberg/Murr",
            "1005": "Spedition Häring",
            "1006": "Spedition Kunzendorf",
            "1007": "Spedition Franz Lerner GmbH",
            "1010": "Elmar Maurus Logistic",
            "1011": "Spedition Ulmschneider",
            "1012": "DHL Freight GmbH",
            "1013": "Spedition Weckerle",
            "1014": "Spedition H. v. Wirth",
            "1017": "UPS",
            "1023": "Spedition Redemann",
            "1032": "Spedition Dachser",
            "1044": "Gert Treitinger Transport Company",
            "1045": "Spedition Rentschler",
            "1046": "DSV Stuttgart",
            "1047": "TNT",
            "1048": "Spedition Dischinger Ebersbach",
            "1049": "Spedition Atege",
            "1051": "Spedition Schmalz + Schön",
            "1053": "Spedition SCS Stuttgart GmbH",
            "1054": "Spedition L.W.Cretschmar GmbH & Co. KG",
            "1055": "Spedition Trautwein",
            "1056": "Spedition L. Wackler Wwe. Nachf. GmbH",
            "1057": "Spedition Dacotrans Grosskopf GmbH & Co. KG",
            "1058": "Ebenroth - Pure Logistics",
            "1059": "HTL-Peter Messner GmbH / Trade-Transport-Logistics",
            "1060": "Kunzendorf Sped. GmbH / Schkeuditz branch",
            "1061": "Spedition ROHLIG SUUS Logistics SA",
            "1062": "Optimal Courier",
            "1063": "Heppner Internationale / Spedition GmbH Co. KG",
            "1064": "DACHSER SE Spedition",
            "1065": "Renz France in FR Shipping",
            "1066": "Renz Poland in PL Shipping",
            "1067": "Inotherm in SI Shipping",
            "1068": "Kühne + Nagel"
        },
        "operationSources": {
            "10": {
                "label": "Back Office"
            },
            "20": {
                "label": "eConfig Pro"
            },
            "30": {
                "label": "eConfig"
            },
            "40": {
                "label": "RIT"
            },
            "50": {
                "label": "eShop"
            },
            "60": {
                "label": "eInfo"
            }
        },
        "installationTypeCodes": {
            "1": "Flush-mounted/Partial wall installation",
            "2": "Surface-mounted installation",
            "3": "Freestanding, front access",
            "4": "Freestanding, rear access",
            "5": "Wall-through installation",
            "6": "Fence installation",
            "7": "Side panel installation, rear access",
            "8": "Contact pillar",
            "9": "Wall-through installation with horizontal boxes",
            "10": "Single installation",
            "11": "Side panel installation, front access",
            "12": "Replacement doors/flaps/cases",
            "13": "Customer-specific fronts",
            "14": "Wall-through installation (Switzerland only)"
        },
        "productGroupCodes": {
            "1": "Renz",
            "2": "Startline",
            "3": "Renz Plan"
        },
        "modelGroupCodes": {
            "10": "Vertical mailboxes, front access",
            "12": "Side panel mailboxes, rear access",
            "13": "Horizontal mailboxes, front access",
            "14": "Wall-mounted, rear access",
            "15": "Commercial/Private Line",
            "16": "Intercom/Bell systems",
            "17": "Fence mailboxes/Individual components",
            "20": "Storage units",
            "21": "Mail distributor systems through-feed",
            "22": "Mail distributor systems front loader",
            "23": "Letter and parcel box systems CLASSIC",
            "25": "Startline vertical mailboxes, front access",
            "26": "Startline horizontal mailboxes, front access",
            "27": "Startline side panel mailboxes, rear access",
            "29": "Budget side panel mailboxes, rear access",
            "30": "Notice boxes",
            "40": "Car dealership boxes",
            "41": "Pharmacy boxes",
            "42": "Security mailboxes",
            "43": "Day/Night mailboxes",
            "50": "Export models Switzerland",
            "58": "Budget horizontal mailboxes, front access",
            "60": "RENZ PLAN vertical mailboxes, front access",
            "61": "RENZ PLAN horizontal mailboxes, front access",
            "62": "RENZ PLAN vertical mailboxes, rear access",
            "63": "RENZ PLAN steles",
            "64": "RENZ PLAN S side panel mailboxes",
            "65": "RENZ PLAN S wall-mounted, rear access",
            "67": "RENZ PLAN S, vertical mailboxes, front access",
            "68": "RENZ PLAN SL, horizontal mailboxes, Switzerland",
            "78": "MEFA",
            "90": "Replacement parts with engraving",
            "97": "Replacement parts"
        }
    },
    "general": {
        "foldIn": "Collapse",
        "removeExceptionFilter": "Remove filter. Note: An exception rule without a filter will be deleted automatically when saving.",
        "exceptionWithoutFilter": "Exception rules without filters are removed automatically. Save universal calculations outside the exception rules.",
        "foldOut": "Expand",
        "logoutWarning": "You will be logged out in {logoutInMinutes} minute{plural} if you remain inactive.",
        "errorOccurred": "An error has occurred! Please reload the page and try again later.",
        "fullText": "Full text",
        "removeFilter": "Remove filter",
        "warning": "Warning",
        "pushDown": "Move down",
        "pushUp": "Move up",
        "restore": "Restore",
        "ok": "OK",
        "yes": "Yes",
        "no": "No",
        "send": "Send",
        "cancel": "Cancel",
        "save": "Save",
        "close": "Close",
        "back": "Back",
        "next": "Next",
        "delete": "Delete",
        "edit": "Edit",
        "noted": "Marked",
        "note": "Mark",
        "beeingLoaded": "Loading...",
        "pleaseWait": "Please wait...",
        "preview": "Preview",
        "logo": "Logo",
        "selectFile": "Select file",
        "legend": "Legend",
        "eMailAddress": "Email address",
        "telephone": "Phone number",
        "webAddress": "Web address",
        "add": "Add",
        "mr": "Mr",
        "mrs": "Ms",
        "others": "Other",
        "planned": "Planned",
        "origin": "Origin",
        "positionShortName": "Pos.",
        "dealerDataNotFound": "Dealer data not found",
        "commission": "Commission",
        "offer": "Offer",
        "order": "Order",
        "actions": "Actions",
        "loadMore": "Load more...",
        "type": "Type",
        "selectType": "Select type",
        "pageNotFound": "Page not found<br /><br />Path: {path}",
        "mandatoryField": "Required field",
        "dataStored": "Data saved",
        "description": "Description",
        "and": "and",
        "rule": "Rule",
        "units": "Units",
        "lookForValue": "Search value",
        "copy": "Copy",
        "share": "Share",
        "entrance": "Entry",
        "exit": "Exit",
        "reset": "⟳ reset",
        "apply": "Apply",
        "email": "Email",
        "phone": "Tel.",
        "duplicate": "Duplicate",
        "accessKeyCreated": "Access key has been created.",
        "accessKeyDeleted": "Access key has been deleted.",
        "newVersionAvailable": "A new version of the software is available.<br>The page will reload.",
        "incompleteInfo": "Not all<br>information is available yet.<br><br>Please try again later."
    }
}